import validate from "D:/a/1/s/WebApi/Frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/a/1/s/WebApi/Frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("D:/a/1/s/WebApi/Frontend/middleware/auth.ts")
}